import React, { Component } from 'react';
import { connect } from 'react-redux';
import getSelectedExtras from 'state/checkoutPage/travelSummary/selectors/getSelectedExtras';
import FlightsExtrasSummaryComponent from './FlightsExtrasSummaryComponent';

class FlightsExtrasSummary extends Component {
  constructor(props) {
    super(props);

    const { summaryType, exclusive } = props;
    this.summaryKey = { summaryType, exclusive };
  }

  render() {
    const { getSelectedExtras } = this.props;
    const selectedExtrasData = getSelectedExtras();

    if (!selectedExtrasData) {
      return null;
    }

    const { Leave = [], Return = [], Both = [] } = selectedExtrasData;

    return (
      <FlightsExtrasSummaryComponent
        summaryKey={this.summaryKey}
        leaveDirection={Leave}
        returnDirection={Return}
        bothDirections={Both}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedFlightsExtras: state.checkoutPageTravelSummary.selectedFlightsExtras, // Required for component update
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSelectedExtras() {
      return dispatch(getSelectedExtras());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsExtrasSummary);
